import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { TransportAutoEntriesCompleteValidationSchema } from '../../../../schemas/forwardings/transport/autoEntries/transportAutoEntriesComplete.schema';
import { unFormatUnknownUnit } from '@/common/utils/unFormatters';

interface UseMaintenanceTransportAutoEntriesCompleteProps {
  checkinEntryId: string;
  deliveryCode?: string;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    TransportAutoEntriesCompleteValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceTransportAutoEntriesComplete = ({
  checkinEntryId,
  deliveryCode,
  options,
}: UseMaintenanceTransportAutoEntriesCompleteProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceTransportAutoEntriesComplete'],
    mutationFn: (form: TransportAutoEntriesCompleteValidationSchema) => {
      const payload = {
        sent_delivery_code: deliveryCode,
        current_equipment_usage: form.current_equipment_usage && unFormatUnknownUnit(form.current_equipment_usage),
        observations: form.observations,
      }

      return privateAxios.post(`/maintenance/transport/auto_entries/${checkinEntryId}/complete`, {
        ...payload,
      });
    },
    ...options
  });
}
